'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M256 0l80 0 0 160 48 0 0 64-160 0 0-64 48 0 0-96-48 0 0-64 32 0zM32 288l80 0 0 160 48 0 0 64-160 0 0-64 48 0 0-96-48 0 0-64 32 0zM0 0L192 0 192 224 0 224 0 0zM64 64l0 96 64 0 0-96-64 0zM224 288l160 0 0 224-192 0 0-224 32 0zm32 160l64 0 0-96-64 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;